import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=4e318954&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=js&"
export * from "./Note.vue?vue&type=script&lang=js&"
import style0 from "./Note.vue?vue&type=style&index=0&id=4e318954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e318954",
  null
  
)

export default component.exports